const routes = [{
  path: '/insurance',
  component: () => import('@/views/insurance'),
  name: 'insurance',
  meta: {
    title: '保单管理/保单查询'
  }
}, {
  path: '/insurance/automatic',
  component: () => import('@/views/insurance/automatic'),
  name: 'insurance-automatic',
  meta: {
    title: '保单管理/自动录单'
  }
}, {
  path: '/insurance/query',
  component: () => import('@/views/insurance/query'),
  name: 'insurance-query',
  meta: {
    title: '保单查询'
  }
}, {
  path: '/insurance/import',
  component: () => import('@/views/insurance/import'),
  name: 'insurance-import',
  meta: {
    title: '保单管理/保单查询/导入列表'
  }
}, {
  path: '/insurance/export',
  component: () => import('@/views/insurance/export'),
  name: 'insurance-export',
  meta: {
    title: '保单管理/保单查询/导出列表'
  }
}, {
  path: '/insurance/task',
  component: () => import('@/views/insurance/task'),
  name: 'insurance-task',
  meta: {
    title: '保单管理/任务列表'
  }
}, {
  path: '/finance/policy',
  component: () => import('@/views/finance/policy'),
  name: 'finance-policy',
  meta: {
    title: '保单设置'
  }
}, {
  path: '/insurance/postback',
  component: () => import('@/views/insurance/postback'),
  name: 'insurance-postback',
  meta: {
    title: '保单数据'
  }
}, {
  path: '/insurance/matchingParticulars',
  component: () => import('@/views/insurance/matchingParticulars'),
  name: 'insurance-matchingParticulars',
  meta: {
    title: '查看匹配政策详情'
  }
}, {
  path: '/insurance/detail',
  component: () => import('@/views/insurance/detail'),
  name: 'insurance-detail',
  meta: {
    title: '保单详情'
  }
}, {
  path: '/insurance/batchAdd',
  component: () => import('@/views/insurance/batchAdd'),
  name: 'insurance-batchAdd',
  meta: {
    title: '保单管理/批量录单'
  }
}, {
  path: '/insurance/add',
  component: () => import('@/views/insurance/add'),
  name: 'insurance-add',
  meta: {
    title: '保单管理/保单录入'
  }
}, {
  path: '/insurance/edit',
  component: () => import('@/views/insurance/edit'),
  name: 'insurance-edit',
  meta: {
    title: '保单管理/保单编辑'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/insurance.js